var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRecommendedProducts(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.241,17.998L16.407,19.581C16.367,19.917 16.245,20.277 16.063,20.564C15.719,21.188 15.192,21.643 14.584,21.835C13.977,22.003 13.328,21.883 12.802,21.452L7.778,17.663C7.535,17.495 7.495,17.159 7.636,16.895C7.778,16.632 8.062,16.559 8.264,16.727L13.308,20.516C13.977,20.996 14.848,20.78 15.273,20.013C15.698,19.245 15.496,18.19 14.848,17.687L8.568,12.986C7.535,12.219 6.34,11.62 5.206,12.291L0,15.792V22.843L3.727,19.557C4.314,19.389 4.963,19.533 5.51,19.941L9.885,23.202C10.958,23.993 12.275,24.185 13.409,23.826L22.889,21.26C23.639,21.068 24.145,20.181 23.963,19.221C23.76,18.358 23.011,17.806 22.241,17.998Z",
    fill: "#909BF1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11,5.313V11.466L16.538,15V8.875L11,5.313ZM17.462,15L23,11.466V5.313L17.462,8.875V15ZM22.538,4.5L17,1L11.462,4.5L17,8L22.538,4.5Z",
    fill: "#909BF1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecommendedProducts);
export default __webpack_public_path__ + "static/media/recommendedProducts.e23c64cfb2e263c4d26440c3165a4662.svg";
export { ForwardRef as ReactComponent };